import React from 'react';
import {
  Box,
  Button,
  Divider,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Typography,
} from '@mui/material';
import { MenuIcon, DefaultUserIconFilled, BackIcon } from 'components/SVG';
import { useCurrentUser } from 'hooks/common/useCurrentUser';
import { Cookies } from 'react-cookie';
import { useQueryClient } from 'react-query';
import { useResize, useSafeNavigate } from 'hooks/common';
import { SPARK_ROUTES } from 'constants/routes';
import { SparkButton } from 'sharedComponents/UI';
import { SparkImageLoader } from 'sharedComponents/UI';

type SettingHeaderProps = {
  toggleDrawer: () => void;
};
const SettingsHeader = React.forwardRef(function SettingsHeader(
  { toggleDrawer }: SettingHeaderProps,
  ref
) {
  const cookies = new Cookies();
  const { handleRouteBack, navigate } = useSafeNavigate();
  const { isMobile } = useResize();
  const queryClient = useQueryClient();
  const { currentUserID, applicationUser } = useCurrentUser();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    cookies.remove('userToken', { path: '/' });
    cookies.remove('userID', { path: '/' });
    queryClient.clear();
    navigate(SPARK_ROUTES.LOGIN);
  };
  return (
    <Grid
      container
      ref={ref as any}
      justifyContent='space-between'
      height='inherit'
      alignItems='center'
    >
      {isMobile ? (
        <Box paddingLeft={1.5}>
          <IconButton onClick={toggleDrawer}>
            <MenuIcon />
          </IconButton>
        </Box>
      ) : (
        <Grid
          container
          gap={1}
          md={2.5}
          lg={2}
          sm={3.5}
          alignItems='center'
          justifySelf='flex-start'
          marginLeft={1.5}
        >
          <Button
            onClick={handleRouteBack}
            sx={{
              minWidth: 'unset',
              width: '40px',
              height: '40px',
              padding: 0,
              borderWidth: '1px',
              borderRadius: '14px',
              borderColor: '#EEEEEE',
            }}
            variant='outlined'
          >
            <BackIcon />
          </Button>
          <Typography
            variant='h6'
            noWrap
            component='a'
            sx={{
              ml: 2,
              color: '#000',
              fontSize: '16px',
              fontStyle: 'normal',
              fontWeight: '700',
              lineHeight: 'normal',
            }}
          >
            Exit Settings
          </Typography>
        </Grid>
      )}

      <Box display='flex'>
        <Button onClick={handleClick}>
          <Box justifyContent='flex-end' sx={{ flexGrow: 1, display: 'flex' }}>
            {currentUserID ? (
              <SparkImageLoader
                src={applicationUser?.attributes?.profilePictureURL || ''}
                alt={applicationUser?.attributes?.profilePictureURL || ''}
                style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                }}
              />
            ) : (
              <DefaultUserIconFilled />
            )}
          </Box>
        </Button>
        {/* <Menu open={open} onClose={handleClose} anchorEl={anchorEl}>
          <MenuItem onClick={() => navigate('/settings/my-profile')}>
            My Profile
          </MenuItem>
          <MenuItem onClick={handleLogout}>Logout</MenuItem>
        </Menu> */}

        <Menu
          open={open}
          onClose={handleClose}
          anchorEl={anchorEl}
          PaperProps={{
            sx: {
              width: '300px',
            },
          }}
        >
          <Box sx={{ padding: 2, textAlign: 'left' }}>
            <Typography variant='h5'>
              {applicationUser?.attributes?.name || ''}
            </Typography>
            <Typography variant='body1' color='textSecondary'>
              {applicationUser?.attributes?.email || ''}
            </Typography>
          </Box>
          <Divider />
          <Box
            sx={{
              padding: 2,
              display: 'flex',
            }}
          >
            <SparkButton
              variant='contained'
              sx={{ borderRadius: '2px', width: '100%' }}
              onClick={() => {
                navigate('/settings/billing-and-usage?subscriptionPopup=1');
                handleCloseMenu();
              }}
            >
              Try Pro
            </SparkButton>
          </Box>
          <Divider />

          <MenuItem
            onClick={() => {
              navigate('/settings/my-profile');
              handleCloseMenu();
            }}
            sx={{ mt: 1 }}
          >
            My Profile
          </MenuItem>

          <Divider />
          <MenuItem onClick={handleLogout}>Logout</MenuItem>
        </Menu>
      </Box>
    </Grid>
  );
});

export default SettingsHeader;
